import { Component } from '@angular/core';

@Component({
  selector: 'app-ngb-carousel-demo',
  templateUrl: './carousel-demo.component.html',
})
export class NgbCarouselDemoComponent {}
